module.exports = __webpack_public_path__ + "static/media/anatomia.1c2b231e.png";